/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { signOut } from "next-auth/react";
import { useParams } from "next/navigation";
import ConfirmationModal from "./application/components/ConfirmationModal";
import { useTranslation } from "../i18n/client";
import { registerSessionExpiredHandler } from "../../lib/sessionEvents";
const DEFAULT_LNG = "en";
const getCallbackUrl = ()=>{
    const base = process.env.NEXT_PUBLIC_CLIENT_URL;
    if (!base) {
        return "/api/auth/login";
    }
    return "".concat(base, "/api/auth/login");
};
export default function SessionExpiryModal() {
    const params = useParams();
    const lng = (params === null || params === void 0 ? void 0 : params.lng) || DEFAULT_LNG;
    const { t } = useTranslation(lng, "translation");
    const [open, setOpen] = useState(false);
    const [isSigningOut, setIsSigningOut] = useState(false);
    // const router = useRouter();
    useEffect(()=>{
        const unsubscribe = registerSessionExpiredHandler(()=>{
            setOpen(true);
        });
        return unsubscribe;
    }, []);
    const handleSignOut = useCallback(async ()=>{
        if (isSigningOut) {
            return;
        }
        setIsSigningOut(true);
        setOpen(false);
        try {
            // await signOut({ redirect: false }); // Set redirect to false to handle redirection manually
            // router.push(`${process.env.NEXT_PUBLIC_CLIENT_URL}`); // Redirect to the desired page after signing out
            // router.refresh();
            await signOut({
                redirect: true,
                callbackUrl: getCallbackUrl()
            });
        } finally{
            setIsSigningOut(false);
        }
    }, [
        isSigningOut
    ]);
    if (!open) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        title: t("sessionExpiredTitle"),
        subtitle: t("sessionExpiredMessage"),
        open: open,
        handleClose: handleSignOut,
        primaryBtnName: t("sessionExpiredConfirm"),
        primaryBtnAction: handleSignOut,
        hideCloseIcon: false
    });
}
